const { createAction } = require("@reduxjs/toolkit");

export const setCheckout = createAction("checkout/setCheckout");
export const completeCheckout = createAction("checkout/complete");
